/**
 * Created by tiedong on 2017/7/21.
 */


import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'
const reducers = {}
const initialState = {
    accidentCars:[]
}

reducers[types.GET_ACCIDENT_CARS] = (state, action) => {
    return Object.assign({}, state, {accidentCars: action.payload.data})
}
export default handleActions(reducers, initialState)